export default __webpack_public_path__ + "static/woman-on-phone-2ec361e63b3ca8ec56e96b42989a8f57.webp";